module.exports = "# Level 1 Intro\n\n## Content\n\n### Welcome, Planet Protectors!\n\n#### Why not start with a song?\n\n## Notes\n\n&nbsp;\n\n# Level 2 Intro\n\n## Content\n\n### Welcome, Planet Protectors!\n\n#### Get ready to sing!\n\n## Notes\n\n&nbsp;\n\n# Song\nYouTube: ulOo2VuQEWA\n\n\n## Notes\n\n### H2Whoa! Song\n\nEncourage your class to learn this song and sing along to the video (3:02).\n\n### Extension Activities\nApprentices can perform the song to the whole school and/or create their own choreography.\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/sections/03_song/song.md
// module id = 1723
// module chunks = 2